export class AuthLogoutDto {

  public readonly logoutUrl!: string;

  constructor(init?: Partial<AuthLogoutDto>) {
    Object.assign(this, init);
  }
}
